import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface SettingState {
  is_loading: Boolean
  is_dark_mode: Boolean
}

export const useSettingStore = defineStore('setting', () => {
  const is_loading = ref(false)
  const is_dark_mode = ref(false)

  return {
    is_loading,
    is_dark_mode,
  }
})
